import React, { memo } from 'react';
import { View, Image, Text } from 'react-native';
import { AppColors } from '../../../../utility/AppColors';
import { AppFontStyle } from '../../../../styles/AppFontStyle';
import { AppImages } from '../../../../utility/AppImages';

interface Participant {
  userID: string;
  username?: string;
  profilePicture?: string;
  status?: "online" | "offline";
}

interface ParticipantDetailsProps {
  participantDetails: Participant[];
  checkInStatus: { organiser: boolean; challenger: boolean };
  eventStartTime: string;
  currentUserId: string;
  isOrganiserId: boolean;
  isUserOnline: boolean;
}

const ParticipantDetails: React.FC<ParticipantDetailsProps> = memo(
  ({ participantDetails, checkInStatus, eventStartTime, currentUserId, isOrganiserId, isUserOnline }) => {
    return (
      <View>
        {participantDetails
          ?.filter((user) => user.userID !== currentUserId)
          ?.map((user, index) => {
            const isOpponentCheckedIn = isOrganiserId
              ? !!checkInStatus?.challenger
              : !!checkInStatus?.organiser;

            const checkInStatusText = (() => {
              const now = new Date();
              const eventTime = new Date(eventStartTime);
              const checkInTime = new Date(eventTime.getTime() - 90 * 60000);

              if (isOpponentCheckedIn) return 'Checked In';
              if (now > eventTime) return 'Missed';
              if (now > checkInTime) return 'Pending';
              return 'Pending';
            })();

            const checkInColor =
              checkInStatusText === 'Checked In'
                ? AppColors.green_16A34A
                : checkInStatusText === 'Pending'
                ? AppColors.yellow_FACC15
                : AppColors.red_CF366E;

            return (
              <View
                key={index}
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  marginTop: index === 0 ? 0 : 8,
                }}
              >
                <View style={{ marginRight: 12 }}>
                  <Image
                    source={user.profilePicture ? { uri: user.profilePicture } : AppImages.icApple}
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 20,
                    }}
                  />
                </View>
                <View style={{ flex: 1, marginRight: 12, gap: 9 }}>
                  <Text style={AppFontStyle.BOLD_ANYBODY_16}>
                    {user.username?.trim() || user.userID?.trim() || 'Unknown'}
                  </Text>
                  <Text style={AppFontStyle.REGULAR_ANYBODY_14}>
                    Check In Status:
                  </Text>
                </View>
                <View style={{ alignItems: 'flex-end', gap: 9 }}>
                  <View
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      marginBottom: 4,
                    }}
                  >
                    <Image
                      source={isUserOnline ? AppImages.User_Online : AppImages.Offline_User}
                      style={{
                        width: 10,
                        height: 10,
                        marginRight: 4,
                        marginBottom: 4,
                      }}
                    />
                    <Text
                      style={{
                        ...AppFontStyle.REGULAR_ANYBODY_14,
                        color: isUserOnline ? AppColors.green_4ADE80 : AppColors.gray_9499A4,
                      }}
                    >
                      {isUserOnline ? 'Online' : 'Offline'}
                    </Text>
                  </View>
                  <Text
                    style={{
                      ...AppFontStyle.BOLD_ANYBODY_16,
                      color: checkInColor,
                    }}
                  >
                    {checkInStatusText}
                  </Text>
                </View>
              </View>
            );
          })}
      </View>
    );
  }
);

export default ParticipantDetails;